import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ActivatedRoute, Router, Routes, RouterModule } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-later-snippet',
  templateUrl: './later-snippet.component.html',
  styleUrls: ['./later-snippet.component.scss']
})
export class LaterSnippetComponent implements OnInit {

  constructor(public ngxSmartModalService: NgxSmartModalService, private spinner: NgxSpinnerService, public http: HttpClient,private location: Location,private route: ActivatedRoute, private router: Router) {this.watchlater() }
  list: any = [];
  loaded:boolean = false;
  isHeadStart = environment.isHeadStart;
  watchlaterlist: any = [];
  siteID = environment.siteID;
  searchMode = true;
  favourites: any = [];
  viewMode = 'favourites';
  validateFree = false;
  fullList: any = [];
  favouritesList: any = [];
  config = {slidesPerView: 'auto',autoHeight: true, navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }, loop: true,
  breakpoints: {
    // when window width is <= 320px
    320: {
      slidesPerView: 'auto',
      spaceBetween: 0
    },
    // when window width is <= 480px
    480: {
      slidesPerView: 'auto',
      spaceBetween: 0
    },
    // when window width is <= 720px
    720: {
      slidesPerView: 'auto',
      spaceBetween: 0
    },
    // when window width is <= 720px
    1000: {
      slidesPerView: 'auto',
      spaceBetween: 0
    }
  }
};
  public watchlater() {
    const myheader = new HttpHeaders().set('Content-Type', 'application/form-data');
      let body = new HttpParams();
    
    this.http.get('https://api-staging.videyo.tv/endpoint/getWatchLater?siteID='+this.siteID,{
      headers:myheader
    })
    .subscribe(
      data => {
        this.watchlaterlist = data['watchLater'];
        this.validateFree = true;
        setTimeout(() => {
          /** spinner ends after 5 seconds */
          this.loaded = true;
        }, 1500);
      },
      error => {
      }
  );
  }
  ngOnInit() {
  }

}
